import React, { Component } from "react"
import PropTypes from "prop-types"
import Icon from "../icon-v2"
import NavGroup from "./NavGroup"
import Components from ".."
import linkHandler from "../../helpers/storyblokLinkHandler"
import {
  StyledPageNav,
  StyledPageNavContainer,
  StyledPageNavLeft,
  StyledPageNavShield,
  StyledPageNavTitle,
  StyledPageNavRight,
  StyledPageNavMenu,
  StyledPageNavMenuItem,
  StyledPageNavMenuItemGroup,
  StyledPageNavButtons,
  StyledPageNavBurger,
  StyledSubHeader,
  StyledPageNavMenuItemGroupContent,
  StyledMainLink,
  StyledAddOnTracks,
  StyledAddOnTrackLabel,
  StyledDash,
} from "./partials/StyledPageNav"
import ButtonV2 from "../button-v2"
import Link from "./Link"
import IconV2 from "../icon-v2"
class PageNav extends Component {
  constructor(props) {
    super(props)
    this.handleClick = this.handleClick.bind(this)
  }
  handleClick() {
    this.props.onClickHandler()
  }

  render() {
    return (
      <StyledPageNav ref={this.props.getRef} isSticky={this.props.isSticky}>
        <StyledPageNavContainer>
          <StyledPageNavLeft>
            {this.props.shield && (
              <StyledPageNavShield isSticky={this.props.isSticky}>
                <img
                  src={this.props.shield.filename}
                  alt={this.props.shield.alt}
                />
              </StyledPageNavShield>
            )}
            {this.props.title && this.props.title.length > 0 && (
              <StyledPageNavTitle isSticky={this.props.isSticky}>
                {this.props.title.map((content) => (
                  <Link
                    url={content.link}
                    label={content.label}
                    target={content.target}
                  />
                ))}
              </StyledPageNavTitle>
            )}
          </StyledPageNavLeft>
          <StyledPageNavRight>
            {this.props.nav && (
              <StyledPageNavMenu>
                {this.props.nav.map((content) => (

                  <StyledPageNavMenuItem pageNavProgram={this.props.pageNavProgram} key={content._uid}>
                    {content.link ? (
                      <a href={linkHandler(content.link)}><p>{content.label}</p></a>
                    ) : (
                        <p>{content.title}</p>
                    )}
                    {content.links && (
                      <StyledPageNavMenuItemGroup>
                        {content.links.map((c) => (
                          <StyledPageNavMenuItemGroupContent dividing_line={c.dividing_line}>
                            {c.sub_header && <StyledSubHeader>{c.sub_header}</StyledSubHeader>}
                            {c.label && 
                              <StyledMainLink>
                                <Link
                                  pageNavProgram={this.props.pageNavProgram}
                                  key={c._uid}
                                  url={c.link}
                                  path={this.props.path}
                                  target={c.target}
                                  label={c.label}
                                  icon={c.icon}
                                />
                              </StyledMainLink>
                            }
                            {c.add_on_tracks &&
                              c.add_on_tracks.map((l) => (
                                <StyledAddOnTracks>
                                  <StyledAddOnTrackLabel>
                                    <Link
                                      pageNavProgram={this.props.pageNavProgram}
                                      key={l._uid}
                                      url={l.link}
                                      path={this.props.path}
                                      target={l.target}
                                      label={l.label}
                                      icon={l.icon}
                                      dash={true}
                                    />
                                  </StyledAddOnTrackLabel>
                                </StyledAddOnTracks>
                              ))}
                          </StyledPageNavMenuItemGroupContent>
                        ))}
                      </StyledPageNavMenuItemGroup>
                    )}
                  </StyledPageNavMenuItem>
                ))}
              </StyledPageNavMenu>
            )}
            {this.props.buttons && (
              <StyledPageNavButtons>
                {this.props.buttons.map((content) => (
                  React.createElement(Components(content.component), {
                    key: content._uid,
                    blok: content,
                    className: "button-v2--thin",
                  })
                  // <ButtonV2
                  //   className="button-v2--thin"
                  //   key={content._uid}
                  //   link={linkHandler(content.link)}
                  //   accessibilityLabel={content.accessibilityLabel}
                  //   variant={content.variant}
                  //   icon={content.icon}
                  //   label={content.label}
                  // />
                ))}
              </StyledPageNavButtons>
            )}
          </StyledPageNavRight>
          <StyledPageNavBurger
            isSticky={this.props.isSticky}
            onClick={this.handleClick}
          >
            <Icon icon="bars" iconType="fal" />
          </StyledPageNavBurger>
        </StyledPageNavContainer>
      </StyledPageNav>
    )
  }
}

export default PageNav
